module.exports = __webpack_public_path__ + "media/src/images/course-page-card_big-6e5464481dc7ecb2e6ad82a39c560727.png";